import { Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-stone-200 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-display text-lg font-medium text-stone-900">
              Dott.ssa Silvia Dal Bello
            </p>
            <p className="text-sm text-stone-500 mt-1">
              Medico Radiologo · Iscrizione Ordine dei Medici di Bergamo
            </p>
            <p className="mt-5 text-sm text-stone-600 max-w-sm leading-relaxed">
              Diagnostica per immagini con un approccio clinico-relazionale.
              Bergamo e provincia.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.22em] text-stone-500 mb-4">
              Naviga
            </p>
            <ul className="space-y-2 text-sm text-stone-700">
              <li><a href="#chi-sono" className="hover:text-[#3E615B]">Chi sono</a></li>
              <li><a href="#approccio" className="hover:text-[#3E615B]">Approccio</a></li>
              <li><a href="#competenze" className="hover:text-[#3E615B]">Competenze</a></li>
              <li><a href="#sedi" className="hover:text-[#3E615B]">Sedi</a></li>
              <li><a href="#faq" className="hover:text-[#3E615B]">FAQ</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.22em] text-stone-500 mb-4">
              Contatti
            </p>
            <ul className="space-y-3 text-sm text-stone-700">
              <li className="flex items-center gap-3">
                <Mail size={14} className="text-[#3E615B]" />
                <a
                  data-testid="footer-email"
                  href="mailto:silviadalbello@casadicurapalazzolo.it"
                  className="hover:text-[#3E615B]"
                >
                  silviadalbello@casadicurapalazzolo.it
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin size={14} className="text-[#3E615B]" />
                <a
                  data-testid="footer-linkedin"
                  href="https://www.linkedin.com/in/silvia-dal-bello-b2ab90183/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#3E615B]"
                >
                  linkedin.com/in/silvia-dal-bello
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-stone-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-stone-500">
            © {new Date().getFullYear()} Dott.ssa Silvia Dal Bello — Tutti i diritti riservati.
          </p>
          <p className="text-xs text-stone-500">
            Le informazioni presenti in questo sito hanno carattere divulgativo e non
            sostituiscono il parere medico.
          </p>
        </div>
      </div>
    </footer>
  );
}
